import { useEffect } from 'react';

/**
 * Sends the browser to an external URL (e.g. Zendesk Resource Center).
 * Used for legacy bookmark compatibility routes inside the portal SPA.
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    if (!to) return;
    window.location.replace(to);
  }, [to]);

  return null;
}
